import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { makeStyles } from '@mui/styles'
import { Grid, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
// import NotificationsIcon from '@mui/icons-material/Notifications'
import CloseIcon from '@mui/icons-material/Close'

import { HueLogoWhiteIcon } from 'assets/icons'

import OnboardingProvider from 'utils/providers/OnboardingProvider'
import { useAuth } from 'utils/providers/AuthProvider'

import SideMenu from '../SideMenu'
import { baseRoutes } from 'constants/routes'
import OnboardingMobileButton from './OnboardingMobileButton'

const useStyles = makeStyles((theme) => {
  return {
    icon: {
      fill: theme.palette.common.white,
    },
    container: {
      backgroundColor: theme.palette.primary.dark,
      padding: '12px 28px',
    },
    logo: {
      width: '106px',
      height: '32px',
    },
    onboardingIndicator: {
      width: 10,
      height: 10,
      backgroundColor: theme.palette.error.main,
      borderRadius: 100,
      position: 'absolute',
      top: '4px',
      right: '4px',
    },
  }
})

const Navbar = () => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const { user } = useAuth()

  return (
    <OnboardingProvider onStepClick={() => setOpen(false)}>
      <Grid
        className={classes.container}
        container
        justifyContent="space-between"
        alignItems="center"
        gap={1}
        flexWrap="nowrap"
        position="fixed"
        top={0}
        zIndex="1200"
      >
        {open ? (
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        ) : (
          <Grid container width="auto" alignItems="center" position="relative">
            <IconButton onClick={() => setOpen(true)}>
              <MenuIcon className={classes.icon} />
            </IconButton>
            {user?.profile?.isOnboardingCompleted ? null : (
              <Grid className={classes.onboardingIndicator} />
            )}
          </Grid>
        )}

        <Link to={`/${baseRoutes.profile}`}>
          <HueLogoWhiteIcon className={classes.logo} />
        </Link>

        <Grid height="40px" width="40px"></Grid>
        {/* 
      <IconButton>
        <NotificationsIcon sx={{ fill: 'white' }} />
      </IconButton> */}
        <SideMenu open={open} setOpen={setOpen} />
        {user?.profile?.isOnboardingCompleted ? null : (
          <OnboardingMobileButton />
        )}
      </Grid>
    </OnboardingProvider>
  )
}

export default Navbar
